import { BehaviorSubject } from 'rxjs';
import url from "variables/url.js";
import { setCookie } from "variables/espolAds.js";

const APP_ID = process.env.REACT_APP_ID;
const localBack = url.localBack;

const currentUser = {
    usuario: "",    
    identificacion: "",
    ultimoCambio: "",
    apellidos: "",
    nombres: "",
    roles: [],
    token: ""
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
};

function login(username) {
    fetch(localBack + "api/Accounts/logincas", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ netid: username })
    })
        .then(response => response.json())
        .then((result) => {

            let loggedUser = {
                usuario: result.username,
                identificacion: result.identificacion,
                apellidos: result.apellidos,
                nombres: result.nombres,
                roles: result.roles,
                token: result.token,                
            };            
            //Cookies que se utilizan en varios componentes
            if (loggedUser != null) {
                setCookie('userEspol', loggedUser.usuario, 2);
                setCookie('token', loggedUser.token, 2);
                setCookie('isAdmin', loggedUser.roles.includes("Administrador"), 2);
                setCookie('isRev', loggedUser.roles.includes("Revisor"), 2);
                setCookie('isCreator', loggedUser.roles.includes("Creador"), 2);
            }
            //Esto ??
            //let realFetch = window.fetch;
            //window.fetch = function (url, opts = null) {
            //    if (loggedUser.token) {
            //        opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `Bearer ${loggedUser.token}` } });
            //        return realFetch(url, opts);
            //    } else {
            //        return realFetch(url, opts);
            //    }
            //};

            currentUserSubject.next(loggedUser);
            window.location.reload();
        });
}

function logout() {
    // remove user and go to logout CAS
    currentUserSubject.next(null);
    window.location.href = "/Account/Logout";
}